export interface IReportChartAxisOption {
  value: string;
  label: string;
}

export enum ReportChartDisplayMode {
  solid = "solid",
  colorByValue = "colorByValue",
  differentColors = "differentColors",
  lineChart = "lineChart",
  pieChart = "pieChart",
}

export interface IReportChartDisplayModeOption {
  value: ReportChartDisplayMode;
  labelKey: string;
}
